module.exports = function() {
  return new Worker(__webpack_public_path__ + "59c8192c3e82e91781a6.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/es5/build/pdf.worker.js
// module id = 704
// module chunks = 1